import i18n from "i18next";

import type { Purpose } from "api/services/appointment/schemas/shared";

export function translateAppointmentPurpose(purpose: Purpose): string {
  const keyMap: Record<Purpose, string> = {
    discharge_call: i18n.t("messages.appointments.types.DISCHARGE_CALL"),
    follow_up: i18n.t("messages.appointments.types.FOLLOW_UP"),
    general: i18n.t("messages.appointments.types.GENERAL"),
    hybrid_call: i18n.t("messages.appointments.types.HYBRID_CALL"),
    kick_off: i18n.t("messages.appointments.types.KICK_OFF"),
  };

  return keyMap[purpose] || "";
}
